<div class="image-wrap picture-container quiz-img">
    <picture>
        <ng-container *ngIf="!resultData; else resultImage">
            <img *ngIf="slide.images.length > 0" class="quiz-image" [src]="slide.images[0].sizes.quiz.urlWithParams" alt="" loading="lazy">
        </ng-container>
        <ng-template #resultImage>
            <img *ngIf="slide.content[resultData.contentIndex].image" class="quiz-image" [src]="slide.content[resultData.contentIndex].image.sizes.quiz.urlWithParams" alt="" loading="lazy">
        </ng-template>
    </picture>

    <div class="photo-controls">
        <a class="button" href="#">{{ getNextText() }}</a>
    </div>

    <div class="photo-extras-wrap no-caption">
        <div class="photo-extras">
            <div class="caption" [innerHTML]="getCaption(false)"></div>
            <div class="caption mobile" [innerHTML]="getCaption(true)"></div>
        </div>
    </div>

    <div class="quiz-info">
        <!-- summary -->
        <span class="summary" *ngIf="!slide.intro && !slide.outro">

            <span class="title" >
                <span class="correct">Correct/Incorrect</span>
            </span>

            <!-- feedback -->
            <span class="content" *ngFor="let f of slide.feedback" [innerHtml]="f.text"></span>

        </span>
        <ng-container *ngIf="slide.outro">
            <h2 class="mobile-only">Congrats, you finished! Here are your results:</h2>

            <!-- summary -->
            <span class="summary end">

                <span class="results cf clearfix">
                    <span class="score">{{ getScore() }}</span>
                    <span class="reset-quiz">
                        <i class="quizicon qretry"></i> Retry
                    </span>
                </span>

                <!-- result title -->
                <span class="title" *ngIf="resultData">
                    <span class="tier reveal">
                        <span class="tier-title" [innerHtml]="slide.content[resultData.contentIndex].title"></span>
                        <span class="tier-content" [innerHtml]="slide.content[resultData.contentIndex].text"></span>
                    </span>
                </span>

            </span>
        </ng-container>
    </div>

</div>